<template>
  <div class="zj-moble-app-page videoConnection">
    <!-- 视频连线邀请 -->
    <div v-show="show">
      <p class="infoTitle">视频连线邀请</p>
      <div class="videoInfo">
        <div class="headInfo">
          <img src="../images/headImg.png" />
        </div>
        <div class="callerInfo">指挥中心视频对话邀请，点击接听...</div>
        <div class="isAcept">
          <div class="refuse" @click="handleLeaveRoom"></div>
          <div class="accept" @click="handleJoinRoom"></div>
        </div>
      </div>
    </div>
    <div v-show="showLeave">
      <p class="infoTitle">视频连线邀请</p>
      <div class="videoInfo">
        <div class="headInfo">
          <img src="../images/headImg.png" />
        </div>
        <div class="callerInfo">通话已结束</div>
        <div class="isLeave">
          <div class="refuse"></div>
        </div>
      </div>
    </div>
    <div class="videoBg" v-show="showVideo">
      <!-- <zj-layout-main > -->
      <!-- zj-layout-main-content -->
      <!-- scrollable -->
      <div class="chat-page chat-video-connect-page" ref="container">
        <div class="local-video chat-audio-video">
          <video
            id="localVideo"
            ref="localVideo"
            autoplay
            muted
            style="height: 100%; width: 100%; object-fit: fill"
          ></video>
          <div class="zj-meeting-remote-peer-statusbar">
            <span class="nickname">{{ nick }}</span>
            <!-- <span class="audio"></span> -->
          </div>
        </div>

        <div class="chat-video-cover-content">
          <!-- <i class="chat-scale"></i> -->
          <p
            class="chat-video-time chat-count-time showTime"
            id="showTime"
            v-if="showtime"
          >
            00 : 00
          </p>
          <div class="chat-video-bottom">
            <div class="chat-video-btn">
              <!-- <i class="chat-video-icon chat-close-microphone"></i>
              <p class="chat-close-msg">静音</p> -->
              <div>
                <div class="voiceBox1" @click="handleMute" v-if="!mute"></div>
                <div class="voiceBox2" @click="handleMute" v-if="mute"></div>
              </div>
            </div>
            <div class="chat-video-btn">
              <div class="closeBtn" @click="handleDeleteRoom"></div>
            </div>
          </div>
        </div>
        <!-- <div class="otherVideoBox" ref="remoteVideos"></div> -->
      </div>

      <!-- </zj-layout-main> -->
      <!-- <div v-if="!bottomShow">
        <div class="showTime" id="showTime"></div>
        <div class="icon_box">
          <div class="voiceBox1" @click="handleMute" v-if="!mute"></div>
          <div class="voiceBox2" @click="handleMute" v-if="mute"></div>
        </div>
        <div class="closeBtn" @click="handleLeaveRoom"></div>
      </div> -->
    </div>
    <!--   <remote-script src="//api.map.baidu.com/api?v=3.0&ak=ERZS9uzwv1zEBuSEAxN5DM5qjZBVHIfq"></remote-script> -->
  </div>
</template>
<script>
import ZJApp from "../../../app";
import MyApis from "../../../../../plugins/map/src/apis";
import { Toast } from "mint-ui";

const ZJMeeting = ZJApp.ZJMeeting;
export default {
  name: "realtimeCall",
  controller: "UI",
  action: "realtimeCall",
  data() {
    return {
      roomId: "room",
      pwd: "123456",
      nick: "大王",
      joined: false,
      mute: false,
      show: true,
      ischangeBig: false, //查看单独某一个人的视频的时候为true
      ExecutId: "",
      second: 0,
      minute: 0,
      hour: 0,
      initTimer: "",
      frontCam: true, //使用前置摄像机为true，使用后置为false
      bottomShow: true,
      msgkey: {
        emergencyVideoCallKey: "MessageKey_EmergencyVideoCall",
      },
      phone: "",
      showtime: false,
      videoCallPageUrl: "/m/RealtimeCall/videoConnection",
      pageTile: "视频通话",
      showLeave: false,
      showVideo: false,
    };
  },
  created() {
    this.nick = this.$route.query.Name;
    this.roomId = this.$route.query.RoomId;
    this.phone = this.$route.query.Phone;

    document.title = this.pageTile;
    if (this.phone) {
      document.title = this.pageTile + this.phone;
    }
  },
  mounted() {
    this.prepareRoom();
    this.startCall();

    // this.startCall("妹妹", "13301561720");
    this.handleJoinRoom();
  },
  destroyed() {
    if (this.mc) {
      this.mc.destroy();
      this.mc = null;
    }
  },
  methods: {
    GotoBack() {
      this.$router.back(-1);
    },
    startCall: function () {
      //发送启动视频通话的消息，服务后台发送视频通话链接给联系人
      let url =
        this.CNF("api.msg_url") +
        this.videoCallPageUrl +
        "?RoomId=" +
        this.roomId +
        "&Name=" +
        this.phone;
      this.sendMsg(
        this.phone,
        "您接收到一条视频通话请求！iPhone请点击此链接进行通话,Android手机请使用chrome浏览器或在微信中打开：" + url
      );
    },
    prepareRoom: function () {
      const that = this;
      const signalServer = this.CNF("meetingCenter.signalServer");
      if (!signalServer) {
        this.$message.error("未配置信令服务器");
        return;
      }
      const remoteVideos = {
        appendPeerStream: function (video, peer) {
          // console.log("video")
          // console.log(video)
          video.style.width = "100%";
          video.style.height = "100%";
          video.style.objectFit = "fill";
          // video.addEventListener("click", function () {
          //   if (!that.ischangeBig) {
          //     video.style.width = "100vw";
          //     video.style.height = "100vh";
          //     var parentDom = video.parentNode;
          //     var nextDom = video.nextElementSibling;
          //     // eslint-disable-next-line no-undef
          //     $(parentDom).addClass("meeting-onlyvedio");
          //     // eslint-disable-next-line no-undef
          //     $(nextDom).addClass("enlarge-statusbar");
          //   } else {
          //     video.style.width = "2.5rem";
          //     video.style.height = "2.5rem";
          //     // eslint-disable-next-line no-undef
          //     $(video.parentNode).removeClass("meeting-onlyvedio");
          //     // eslint-disable-next-line no-undef
          //     $(video.nextElementSibling).removeClass("enlarge-statusbar");
          //   }
          //   that.ischangeBig = !that.ischangeBig;
          // });
          // video.addEventListener('click',that.getOtherVideo(video))
          let div = document.createElement("div");
          div.className = "remote-video chat-audio-video";
          div.style = "width:100%;height:100%;";
          div.id = "zj-meeting-remote-peer-" + peer.id;
          // div.addEventListener('click',that.getOtherVideo(video))
          that.$refs.container.appendChild(div);
          div.appendChild(video);
          // div.appendChild(htmlstr);
          let statusDiv = document.createElement("div");
          statusDiv.className = "zj-meeting-remote-peer-statusbar";
          div.appendChild(statusDiv);
          statusDiv.innerHTML =
            '<span class="nickname">' + (peer.nick || "未知") + "</span>";
        },
        removePeerStream: function (video, peer) {
          // console.log("aaa")
          // console.log(video)
          // console.log(peer)
          // video, peer
          let id = "zj-meeting-remote-peer-" + peer.id;
          let div = that.$refs.container.querySelector("#" + id);
          that.$refs.container.removeChild(div);
        },
        setMute: function (id, value) {
          let containerId = "zj-meeting-remote-peer-" + id;
          let container = that.$refs.container.querySelector("#" + containerId);
          let audioSpan = container.querySelector("span.audio");
          audioSpan.innerHTML = value ? "静音" : "";
        },
      };
      //console.log('signalServer', signalServer);
      this.mc = new ZJMeeting.MeetingCenter({
        debug: false,
        signalServer: signalServer,
        autoConnect: false,

        localVideoEl: this.$refs.localVideo,
        remoteVideosEl: remoteVideos,
        autoRemoveVideos: true,
        autoRequestMedia: false,
        enableDataChannels: false,
        media: {
          audio: {
            noiseSuppression: true,
            echoCancellation: true,
          },
          video: {
            facingMode: this.frontCam ? "user" : "environment", // 前置摄像头/默认摄像机
          },
        },
      });
      window.mc = this.mc;
      this.mc.on("error", function (e) {
        that.$message.error(e.toString());
      });

      this.mc.on("readyToCall", function () {
        that.mc.joinRoom({
          name: that.roomId, // 房间名称
          pwd: that.pwd, // 密码
          nick: that.nick, // 昵称
        });
      });

      this.mc.on("leftRoom", function () {
        setTimeout(function () {
          that.mc.disconnect();
        }, 0);
        that.mc.stopLocalVideo();
        that.mute = false;
      });

      //解散房间
      this.mc.on("deleteRoom", function () {
        Toast({ message: "房间已经被解散" });

        that.handleDeleteRoom();
      });

      this.mc.on("mute", function () {
        console.log("对方静音");
        //remoteVideos.setMute(e.id, true);
      });

      this.mc.on("unmute", function () {
        console.log("对方解除静音");
        //remoteVideos.setMute(e.id, false);
      });
      this.mc.on("videoAdded", function (video, peer) {
        that.handleRemoteJoinRoom();
        console.log("有加入", video, peer);

        //remoteVideos.setMute(e.id, true);
      });
    },
    //对方加入房间
    handleRemoteJoinRoom() {
      //通话计时开始
      this.start();
      this.showtime = true;
    },
    // 加入房间
    handleJoinRoom() {
      if (this.joined) {
        return;
      }
      this.joined = true;
      this.mc.config.media.video.facingMode = this.frontCam
        ? "user"
        : "environment";
      this.mc.startLocalVideo();
      this.mc.connect();
      //显示视频，初始连线状态关闭
      this.show = false;
      this.showLeave = false;
      this.showVideo = true;
    },
    handleLeaveRoom() {
      if (!this.joined) {
        return;
      }
      this.joined = false;
      clearInterval(this.initTimer);
      this.mc.leaveRoom();
      //关闭视频，连线状态关闭
      this.show = true;
    },
    handleDeleteRoom() {
      if (!this.joined) {
        return;
      }
      this.joined = false;
      clearInterval(this.initTimer);
      this.mc.deleteRoom();
     this.show = false;
      this.showLeave = true;
      this.showVideo = false;
      this.shutdown();
    },
    handleMute() {
      if (this.mute) {
        this.mute = false;
        this.mc.unmute();
      } else {
        this.mute = true;
        this.mc.mute();
      }
    },
    getSelfVideo() {
      let videoDom = this.$refs.localVideo;
      if (!this.ischangeBig) {
        this.bottomShow = false;
        videoDom.style.width = "100vw";
        videoDom.style.height = "100vh";
        var parentDom = videoDom.parentNode;
        parentDom.setAttribute("class", "meeting-onlyvedio");
        var nextDom = videoDom.nextElementSibling;
        // eslint-disable-next-line no-undef
        $(nextDom).addClass("enlarge-statusbar");
      } else {
        this.bottomShow = true;
        videoDom.style.width = "2.5rem";
        videoDom.style.height = "2.5rem";
        parentDom = videoDom.parentNode;
        parentDom.removeAttribute("class", "meeting-onlyvedio");
        nextDom = videoDom.nextElementSibling;
        // eslint-disable-next-line no-undef
        $(nextDom).removeClass("enlarge-statusbar");
      }
      this.ischangeBig = !this.ischangeBig;
    },
    start() {
      this.initTimer = setInterval(this.animation, 1000);
    },
    animation() {
      // var second = this.second;
      // var minute = this.minute;
      // var hour = this.hour
      this.second += 1;
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1;
      }

      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1;
      }
      if (this.hour == 0) {
        document.getElementById("showTime").innerHTML =
          this.toShowtimeStr(this.minute) +
          ":" +
          this.toShowtimeStr(this.second);
      } else {
        document.getElementById("showTime").innerHTML =
          this.toShowtimeStr(this.hour) +
          ":" +
          this.toShowtimeStr(this.minute) +
          ":" +
          this.toShowtimeStr(this.second);
      }
    },
    toShowtimeStr(value) {
      if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    },
    sendMsg(phone, message) {
      let that = this;
      if (this.phone != null) {
        new MyApis.SendSmsApi()
          .SendSms({
            // Id: 1,
            Id: ZJApp.ZJUtils.uuid(),
            PhoneNo: phone,
            Content: message,
            Charset: "GBK",
            Creater: "会议中心",
            CreateTime: new Date(),
            Modifier: "会议中心",
            ModifyTime: new Date(),
            SendTime: new Date(),
            Extends2: this.phone,
          })
          .then((r) => {
            r = r.data.Data;
            if (r) {
              console.log("视频通话邀请发送成功roomid:" + that.roomId);
            } else {
              Toast({ message: "视频通话邀请发送失败!" });
            }
          })
          .catch((e) => {
            console.error(e);
            Toast({
              message: e.RspMsg ? e.RspMsg : "视频通话邀请发送失败!",
            });
          });
      } else {
        Toast({ message: "电话号码不能为空" });

        return;
      }
    },
     shutdown() {
      var userAgent = navigator.userAgent;
      if (this.isWeiXin()) {
        window.WeixinJSBridge.call("closeWindow");
      }
      if (!this.isPc()) {
        window.opener = null;
        window.open("about:blank", "_self", "").close();
      }
      if (
        userAgent.indexOf("Firefox") != -1 ||
        userAgent.indexOf("Chrome") != -1
      ) {
        window.location.href = "about:blank";
      } else {
        window.opener = null;
        window.open("about:blank", "_self");
        window.close();
      }
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    isPc() {
      var userAgent = navigator.userAgent;
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgent.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>
<style type="text/css" scoped>
.infoTitle {
  font-size: 0.34rem;
  color: #333333;
  text-align: center;
  margin: 0.33rem auto 0.25rem;
}
.videoInfo {
  width: 6.9rem;
  height: 3.97rem;
  background: url("../images/bigbg.png") no-repeat;
  background-size: cover;
  position: relative;
  margin: 0 auto;
  padding-top: 2.2rem;
  box-sizing: border-box;
}
.headInfo {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 1px solid #fff;
  position: absolute;
  left: 50%;
  margin-left: -0.77rem;
  top: 0.46rem;
  z-index: 99;
  padding: 0.15rem;
}
.headInfo img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.callerInfo {
  font-size: 0.28rem;
  color: #fff;
  text-align: center;
}
.isAcept {
  position: absolute;
  left: 1.82rem;
  bottom: 0.44rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 3.14rem;
}

.isLeave {
  position: absolute;
  bottom: 0.44rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.9rem;
}
.refuse {
  width: 0.64rem;
  height: 0.64rem;
  background: url("../images/refuse.png") no-repeat;
  background-size: cover;
}
.accept {
  width: 0.64rem;
  height: 0.64rem;
  background: url("../images/accept.png") no-repeat;
  background-size: cover;
}
.otherTask {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
  padding: 0 0.3rem;
}

.zj-layout-main-content video {
  /*  width: 2.5rem !important;
  height: 2.5rem !important;*/
}
.otherVideoBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.otherVideoBox video {
  width: 2.5rem !important;
  height: 2.5rem !important;
}
.videoBg {
  width: 100%;
  height: 100%;
  background: #162029;
  position: fixed;
  top: 0;
  left: 0;
}
.closeBtn {
  width: 1.18rem;
  height: 1.68rem;
  background: url("../images/cancle.png") no-repeat;
  background-size: cover;
}
.flexstart {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.showTime {
  width: 100%;
  font-size: 0.31rem;
  color: #fff;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 4.8rem;
  z-index: 99999;
}
.icon_box {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 2.9rem;
  z-index: 999;
  padding: 0 1.14rem;
  box-sizing: border-box;
}
.voiceBox1 {
  width: 1.18rem;
  height: 1.68rem;
  background: url("../images/novoice1.png") no-repeat;
  background-size: cover;
}
.voiceBox2 {
  width: 1.18rem;
  height: 1.68rem;
  background: url("../images/novoice2.png") no-repeat;
  background-size: cover;
}

/* 重新布局视频通话 */
.chat-page {
  background-color: #000;
  position: fixed;
  z-index: 10000;
  border-radius: 4px;
  overflow: hidden;
}

.chat-page div,
p {
  margin: 0;
  padding: 0;
  border: none;
}

.chat-video-connect-page {
  width: 100%;
  /* left: calc(50% - 180px); */
  position: absolute;
  height: 100%;
}

.chat-video-connect-page .local-video {
  width: 2rem;
  height: 3rem;
  position: absolute;
  right: 0.4rem;
  top: 0.4rem;
  -o-object-fit: cover;
  object-fit: cover;
  z-index: 2;
}

.chat-video-connect-page .local-video-mobile {
  width: 120px;
  height: 72px;
  position: relative;
  left: 10px;
  top: 10px;
}
.remote-video {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
}

.chat-video-connect-page .remote-video {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
}

.chat-video-connect-page .chat-video-bottom {
  width: 5rem;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  bottom: 1.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 2;
}

.chat-video-connect-page .chat-video-btn {
  text-align: center;
}

.chat-video-connect-page .chat-video-btn p {
  margin-top: 10px;
  font-size: 12px;
  line-height: 12px;
  height: 12px;
}

.chat-video-connect-page .chat-video-icon {
  display: inline-block;
  background-size: contain;
  width: 56px;
  height: 56px;
}

.chat-blur,
.chat-toast-hide {
  display: none;
}

.chat-video-connect-page .chat-scale {
  position: absolute;
  right: 30px;
  top: 30px;
  width: 25px;
  height: 30px;
  display: inline-block;
  background-image: url(//repo.bfw.wiki/bfwrepo/image/60928e64293d9.png);
  background-repeat: no-repeat;
}

.chat-video-connect-page .chat-video-time {
  width: 5rem;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  bottom: 3.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.chat-video-connect-page .chat-close-microphone,
.chat-video-connect-page .chat-close-microphone:active {
  background-image: url(//repo.bfw.wiki/bfwrepo/image/60928ebfbb282.png);
}

.chat-video-connect-page .chat-open-microphone,
.chat-video-connect-page .chat-open-microphone:active {
  background-image: url(//repo.bfw.wiki/bfwrepo/image/60928eb6912cd.png);
}

.chat-video-connect-page .chat-cancel,
.chat-video-connect-page .chat-cancel:active {
  background-image: url(//repo.bfw.wiki/bfwrepo/image/60928e9ca2a7b.png);
}

.chat-video-connect-page .chat-switch-audio,
.chat-video-connect-page .chat-switch-audio:active {
  background-image: url(//repo.bfw.wiki/bfwrepo/image/60928e512702e.png);
}
</style>